import styled from '@emotion/styled';

export const ItemsGridContainer = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(min(18rem, 100%), 1fr));
    row-gap: 2rem;
    column-gap: 2rem;
`;
